import { HTMLProps } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { useTranslation } from 'react-i18next';
import { InvestmentTable } from '../InvestmentTable';
import { ColumnSelectionType } from '../InvestmentTable/columns';
import { TimeRange } from '../../types';
import { BasicInvestment, getRelatedCollections, getStockPeers } from '../../apis/backend';
import RelatedCollections from './RelatedCollections';
import SectionHeading from './SectionHeading';

interface Props extends HTMLProps<HTMLDivElement> {
  symbol: string;
}

function Related({ symbol, ...props }: Props) {
  const { t } = useTranslation();
  const investmentTableData: UseQueryResult<BasicInvestment[], unknown> = useQuery(
    ['investments', symbol, 'peers'],
    async () => await getStockPeers(symbol),
  );
  const dataCollections: UseQueryResult<Omit<Collection, 'investments'>[]> = useQuery(
    ['collections', symbol],
    async () => await getRelatedCollections(symbol),
  );

  const showCollections = dataCollections.data && dataCollections.data.length > 0;
  const showInvestments = !(!investmentTableData.data || investmentTableData.data.length < 1);

  return (
    <div {...props}>
      {showCollections && (
        <div>
          <SectionHeading text={t('symbol.appearsIn')} />
          <RelatedCollections dataCollections={dataCollections} />
        </div>
      )}
      {showInvestments && (
        <div>
          <SectionHeading text={t('symbol.relatedIndustryPeers')} />
          <InvestmentTable
            investments={investmentTableData.data!}
            columnSelections={[
              { type: ColumnSelectionType.Name },
              { type: ColumnSelectionType.Symbol },
              { type: ColumnSelectionType.ChangePercent, timeRange: TimeRange.months1 },
            ]}
            sortingRule={{ id: 'name' }}
          />
        </div>
      )}
    </div>
  );
}

export default Related;
